var Endian = (function () {
    function Endian() {
    }
    return Endian;
}());
export { Endian };
/**
 * Indicates the most significant byte of the multibyte number appears first in the sequence of bytes.
 * The hexadecimal number 0x12345678 has 4 bytes (2 hexadecimal digits per byte).
 */
Endian.BIG_ENDIAN = "bigEndian";
/**
 * Indicates the least significant byte of the multibyte number appears first in the sequence of bytes.
 * The hexadecimal number 0x12345678 has 4 bytes (2 hexadecimal digits per byte).
 */
Endian.LITTLE_ENDIAN = "littleEndian";
